import React from "react";
import { string } from "yup";
import Input from "./Base";
import InputMaskWithRef from "./InputMaskWithRef";
const phoneNumberRegex = /^\(?([0,2-9][0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const phoneNumberErrorMessage = "Please enter a valid mobile number.";
const phoneNumberMask = ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
export const schema = string().required("A mobile number is required.").matches(phoneNumberRegex, phoneNumberErrorMessage);
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ref,
  label: "Mobile Number",
  InputComponent: InputMaskWithRef,
  required: true,
  type: "tel",
  mask: phoneNumberMask,
  autoComplete: "tel-national",
  ...props
}));
